// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/telegram_analytics.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/telegram_analytics.proto.
 */
export const file_v1_telegram_analytics: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_protobuf_timestamp]);

/**
 * @generated from message v1.GetTelegramUsageSummaryRequest
 */
export type GetTelegramUsageSummaryRequest = Message<"v1.GetTelegramUsageSummaryRequest"> & {
  /**
   * Inclusive first day of the period, YYYY-MM-DD, read as a Vietnam date.
   *
   * @generated from field: string start_date = 1;
   */
  startDate: string;

  /**
   * Inclusive last day of the period, YYYY-MM-DD, read as a Vietnam date.
   *
   * @generated from field: string end_date = 2;
   */
  endDate: string;
};

/**
 * Describes the message v1.GetTelegramUsageSummaryRequest.
 * Use `create(GetTelegramUsageSummaryRequestSchema)` to create a new message.
 */
export const GetTelegramUsageSummaryRequestSchema: GenMessage<GetTelegramUsageSummaryRequest> = /*@__PURE__*/
  messageDesc(file_v1_telegram_analytics, 0);

/**
 * @generated from message v1.GetTelegramUsageSummaryResponse
 */
export type GetTelegramUsageSummaryResponse = Message<"v1.GetTelegramUsageSummaryResponse"> & {
  /**
   * Every message created in the period, from any source.
   *
   * @generated from field: int64 total_messages = 1;
   */
  totalMessages: bigint;

  /**
   * Messages created in the period that came from the Telegram bot.
   *
   * @generated from field: int64 telegram_messages = 2;
   */
  telegramMessages: bigint;

  /**
   * Users with a linked Telegram account, as of now.
   *
   * @generated from field: int64 linked_users = 3;
   */
  linkedUsers: bigint;

  /**
   * All users, as of now.
   *
   * @generated from field: int64 total_users = 4;
   */
  totalUsers: bigint;
};

/**
 * Describes the message v1.GetTelegramUsageSummaryResponse.
 * Use `create(GetTelegramUsageSummaryResponseSchema)` to create a new message.
 */
export const GetTelegramUsageSummaryResponseSchema: GenMessage<GetTelegramUsageSummaryResponse> = /*@__PURE__*/
  messageDesc(file_v1_telegram_analytics, 1);

/**
 * @generated from message v1.GetTelegramUsageDailyRequest
 */
export type GetTelegramUsageDailyRequest = Message<"v1.GetTelegramUsageDailyRequest"> & {
  /**
   * @generated from field: string start_date = 1;
   */
  startDate: string;

  /**
   * @generated from field: string end_date = 2;
   */
  endDate: string;
};

/**
 * Describes the message v1.GetTelegramUsageDailyRequest.
 * Use `create(GetTelegramUsageDailyRequestSchema)` to create a new message.
 */
export const GetTelegramUsageDailyRequestSchema: GenMessage<GetTelegramUsageDailyRequest> = /*@__PURE__*/
  messageDesc(file_v1_telegram_analytics, 2);

/**
 * One day of activity. Days with no messages at all are omitted.
 *
 * @generated from message v1.TelegramUsageDailyPoint
 */
export type TelegramUsageDailyPoint = Message<"v1.TelegramUsageDailyPoint"> & {
  /**
   * The day, YYYY-MM-DD, in Vietnam time.
   *
   * @generated from field: string day = 1;
   */
  day: string;

  /**
   * @generated from field: int64 total_messages = 2;
   */
  totalMessages: bigint;

  /**
   * @generated from field: int64 telegram_messages = 3;
   */
  telegramMessages: bigint;
};

/**
 * Describes the message v1.TelegramUsageDailyPoint.
 * Use `create(TelegramUsageDailyPointSchema)` to create a new message.
 */
export const TelegramUsageDailyPointSchema: GenMessage<TelegramUsageDailyPoint> = /*@__PURE__*/
  messageDesc(file_v1_telegram_analytics, 3);

/**
 * @generated from message v1.GetTelegramUsageDailyResponse
 */
export type GetTelegramUsageDailyResponse = Message<"v1.GetTelegramUsageDailyResponse"> & {
  /**
   * @generated from field: repeated v1.TelegramUsageDailyPoint points = 1;
   */
  points: TelegramUsageDailyPoint[];
};

/**
 * Describes the message v1.GetTelegramUsageDailyResponse.
 * Use `create(GetTelegramUsageDailyResponseSchema)` to create a new message.
 */
export const GetTelegramUsageDailyResponseSchema: GenMessage<GetTelegramUsageDailyResponse> = /*@__PURE__*/
  messageDesc(file_v1_telegram_analytics, 4);

/**
 * @generated from message v1.GetTelegramUsageByUserRequest
 */
export type GetTelegramUsageByUserRequest = Message<"v1.GetTelegramUsageByUserRequest"> & {
  /**
   * @generated from field: string start_date = 1;
   */
  startDate: string;

  /**
   * @generated from field: string end_date = 2;
   */
  endDate: string;

  /**
   * 1-based. Zero is treated as 1.
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * Zero is treated as the default of 25. Capped at 100.
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: v1.TelegramUsageSortField sort_by = 5;
   */
  sortBy: TelegramUsageSortField;

  /**
   * True sorts descending. Ignored for USERNAME, which is always ascending.
   *
   * @generated from field: bool sort_desc = 6;
   */
  sortDesc: boolean;
};

/**
 * Describes the message v1.GetTelegramUsageByUserRequest.
 * Use `create(GetTelegramUsageByUserRequestSchema)` to create a new message.
 */
export const GetTelegramUsageByUserRequestSchema: GenMessage<GetTelegramUsageByUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_telegram_analytics, 5);

/**
 * One user's activity in the period. Users who sent nothing still appear, with
 * zero counts, so the adoption rate stays visible.
 *
 * @generated from message v1.TelegramUsageUserRow
 */
export type TelegramUsageUserRow = Message<"v1.TelegramUsageUserRow"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * Empty when the user has not linked Telegram.
   *
   * @generated from field: string telegram_username = 2;
   */
  telegramUsername: string;

  /**
   * Unset when the user has not linked Telegram.
   *
   * @generated from field: google.protobuf.Timestamp telegram_linked_at = 3;
   */
  telegramLinkedAt?: Timestamp;

  /**
   * @generated from field: int64 total_messages = 4;
   */
  totalMessages: bigint;

  /**
   * @generated from field: int64 telegram_messages = 5;
   */
  telegramMessages: bigint;

  /**
   * Unset when the user sent no Telegram message in the period.
   *
   * @generated from field: google.protobuf.Timestamp last_telegram_at = 6;
   */
  lastTelegramAt?: Timestamp;
};

/**
 * Describes the message v1.TelegramUsageUserRow.
 * Use `create(TelegramUsageUserRowSchema)` to create a new message.
 */
export const TelegramUsageUserRowSchema: GenMessage<TelegramUsageUserRow> = /*@__PURE__*/
  messageDesc(file_v1_telegram_analytics, 6);

/**
 * @generated from message v1.GetTelegramUsageByUserResponse
 */
export type GetTelegramUsageByUserResponse = Message<"v1.GetTelegramUsageByUserResponse"> & {
  /**
   * @generated from field: repeated v1.TelegramUsageUserRow rows = 1;
   */
  rows: TelegramUsageUserRow[];

  /**
   * Total matching users, for paging.
   *
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message v1.GetTelegramUsageByUserResponse.
 * Use `create(GetTelegramUsageByUserResponseSchema)` to create a new message.
 */
export const GetTelegramUsageByUserResponseSchema: GenMessage<GetTelegramUsageByUserResponse> = /*@__PURE__*/
  messageDesc(file_v1_telegram_analytics, 7);

/**
 * TelegramUsageSortField names the column the per-user list is ordered by.
 *
 * @generated from enum v1.TelegramUsageSortField
 */
export enum TelegramUsageSortField {
  /**
   * @generated from enum value: TELEGRAM_USAGE_SORT_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TELEGRAM_USAGE_SORT_FIELD_TELEGRAM_MESSAGES = 1;
   */
  TELEGRAM_MESSAGES = 1,

  /**
   * @generated from enum value: TELEGRAM_USAGE_SORT_FIELD_TOTAL_MESSAGES = 2;
   */
  TOTAL_MESSAGES = 2,

  /**
   * @generated from enum value: TELEGRAM_USAGE_SORT_FIELD_USERNAME = 3;
   */
  USERNAME = 3,

  /**
   * @generated from enum value: TELEGRAM_USAGE_SORT_FIELD_LAST_TELEGRAM_AT = 4;
   */
  LAST_TELEGRAM_AT = 4,
}

/**
 * Describes the enum v1.TelegramUsageSortField.
 */
export const TelegramUsageSortFieldSchema: GenEnum<TelegramUsageSortField> = /*@__PURE__*/
  enumDesc(file_v1_telegram_analytics, 0);

/**
 * TelegramAnalyticsService reports how much of the product runs through the
 * Telegram bot. A message counts as Telegram-originated when it carries a
 * telegram_message_id. Bot commands are not recorded anywhere and are
 * therefore out of scope.
 *
 * @generated from service v1.TelegramAnalyticsService
 */
export const TelegramAnalyticsService: GenService<{
  /**
   * Get the headline counts for a period: total messages, Telegram messages,
   * and how many users have linked Telegram.
   *
   * @generated from rpc v1.TelegramAnalyticsService.GetTelegramUsageSummary
   */
  getTelegramUsageSummary: {
    methodKind: "unary";
    input: typeof GetTelegramUsageSummaryRequestSchema;
    output: typeof GetTelegramUsageSummaryResponseSchema;
  },
  /**
   * Get one row per day in the period, with the total and the Telegram share.
   *
   * @generated from rpc v1.TelegramAnalyticsService.GetTelegramUsageDaily
   */
  getTelegramUsageDaily: {
    methodKind: "unary";
    input: typeof GetTelegramUsageDailyRequestSchema;
    output: typeof GetTelegramUsageDailyResponseSchema;
  },
  /**
   * Get per-user counts for the period, including users who sent nothing.
   *
   * @generated from rpc v1.TelegramAnalyticsService.GetTelegramUsageByUser
   */
  getTelegramUsageByUser: {
    methodKind: "unary";
    input: typeof GetTelegramUsageByUserRequestSchema;
    output: typeof GetTelegramUsageByUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_telegram_analytics, 0);

